<template>
  <div class="news">
    <div class="notice">
      <div>
        <i></i>
        <h3>重要通知</h3>
      </div>
      <RouterLink
        target="_blank"
        :to="`/news/notice?firstCate=${domainList?.chID}&secondCate=${domainList?.coID}`"
      >
        更多 <el-icon><ArrowRight /></el-icon
      ></RouterLink>
    </div>
    <Transition name="fade">
      <div v-if="noticeList.length" class="notice-news">
        <ul>
          <li v-for="item in noticeList" :key="item._id">
            <RouterLink
              target="_blank"
              :title="item.neName"
              :to="`/news/newsdetail?clID=${domainList?.clID}&id=${item._id}`"
            >
              {{ item.neName }}</RouterLink
            >
          </li>
        </ul>
      </div>
      <NoticeNewsSkeleton v-else />
    </Transition>
  </div>
</template>

<script>
import NoticeNewsSkeleton from "./notice-news-skeleton.vue";
export default {
  components: {
    NoticeNewsSkeleton,
  },
  props: {
    noticeList: {
      type: Array,
      default: () => [],
    },
    domainList: {
      type: Object,
      default: () => {},
    },
  },
  setup() {
    return {};
  },
};
</script>

<style lang="less" scoped>
.news {
  width: 400px;
  height: 225px;
  border: 1px solid #f4f4f4;
  .notice {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 400px;
    height: 40px;
    overflow: hidden;
    border: 1px solid rgb(244, 244, 244);
    background: rgb(244, 244, 244);
    div {
      display: flex;
      align-items: center;
      i {
        display: inline-block;
        width: 3px;
        height: 20px;
        background: @shColor;
      }
      h3 {
        margin-left: 10px;
      }
    }
    a {
      display: flex;
      align-items: center;
      color: #999;
      &:hover {
        color: @shColor;
      }
    }
  }
  .notice-news {
    width: 400px;
    height: 185px;
    padding-top: 5px;
    //border: 1px solid #f4f4f4;
    ul {
      width: 400px;
      li {
        padding: 5px 5px 5px 5px;
        & :hover {
          color: @shColor;
          cursor: pointer;
        }
        a {
          display: inline-block;
          width: 400px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          padding-right: 10px;
        }
      }
    }
  }
}
</style>
